/* ============================================
   NLB Sticky ATC Bar - NuLifeBeauty
   ============================================
   Behavior:
   - Appears only when the real ATC button has scrolled
     ABOVE the viewport (user scrolled past it going down)
   - Stays hidden when the ATC is still below the viewport
     (user hasn't reached it yet) or inside it
   - Always proxies clicks to the real theme ATC button,
     inheriting all native behavior (cart drawer,
     cross-sell popup, redirects, etc.)
   ============================================ */

(function () {
  'use strict';

  var bar, button, realAtc, observer;
  var visible = false;

  function findRealAtc() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    return form.querySelector('[name="add"]')
        || form.querySelector('button[type="submit"]')
        || form.querySelector('input[type="submit"]');
  }

  function show() {
    if (visible || !bar) return;
    bar.classList.add('nlbsa-visible');
    bar.setAttribute('aria-hidden', 'false');
    visible = true;
  }

  function hide() {
    if (!visible || !bar) return;
    bar.classList.remove('nlbsa-visible');
    bar.setAttribute('aria-hidden', 'true');
    visible = false;
  }

  function onStickyClick(e) {
    e.preventDefault();
    var target = findRealAtc();
    if (!target) {
      console.warn('[NLBSA] Could not find real ATC button to proxy click');
      return;
    }
    target.click();
  }

  function startObserving() {
    realAtc = findRealAtc();
    if (!realAtc) return false;

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // ATC is in view -> hide
          hide();
        } else if (entry.boundingClientRect.top < 0) {
          // ATC is ABOVE the viewport -> user scrolled past it -> show
          show();
        } else {
          // ATC is BELOW the viewport -> user hasn't reached it yet -> hide
          hide();
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px 0px 0px'
    });

    observer.observe(realAtc);
    return true;
  }

  function init() {
    bar = document.getElementById('nlbsa-bar');
    button = document.getElementById('nlbsa-button');
    if (!bar || !button) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback for ancient browsers: just show on any scroll past a threshold
      var fallbackHandler = function () {
        if (window.pageYOffset > 600) show(); else hide();
      };
      window.addEventListener('scroll', fallbackHandler, { passive: true });
      button.addEventListener('click', onStickyClick);
      return;
    }

    if (!startObserving()) {
      bar.style.display = 'none';
      return;
    }

    button.addEventListener('click', onStickyClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();